// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SketchSquareFilledSvg from "@ant-design/icons-svg/es/asn/SketchSquareFilled";
import AntdIcon from '../components/AntdIcon';

var SketchSquareFilled = function SketchSquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SketchSquareFilledSvg
  }));
};

SketchSquareFilled.displayName = 'SketchSquareFilled';
export default React.forwardRef(SketchSquareFilled);